<template>
  <div v-if="modalTermOpened">
    <slot />
  </div>
</template>

<script>

export default {
  name: 'modal-term',
  model: {
    prop: 'modalTermOpened',
    event: 'close'
  },
  props: {
    modalTermOpened: {
      type: Boolean,
      default: false
    },
    termId: Number
  },
  data () {
    return {
      windowRef: null
    }
  },
  watch: {
    modalTermOpened (newOpen) {
      if (newOpen) {
        this.openModalTerm()
      } else {
        this.closeModalTerm()
      }
    }
  },
  methods: {
    openModalTerm () {
      if (this.termId !== undefined && this.termId > 0) {
        this.windowRef = window.open('/teconecto/?termId=' + this.termId, '_blank')
        this.windowRef.addEventListener('beforeunload', this.closeModalTerm)
      }
    },
    closeModalTerm () {
      if (this.windowRef) {
        this.windowRef.close()
        this.windowRef = null
        this.$emit('close')
      }
    }
  },
  mounted () {
    if (this.open) {
      this.openModalTerm()
    }
  },
  beforeDestroy () {
    if (this.windowRef) {
      this.closeModalTerm()
    }
  }
}
</script>
